// @flow

import React from 'react';
import type { Node } from 'react';
import { breakpointsToArray } from '../../../../helpers';
import { Flex } from '../../../grid';
import FormRow from '../../formRow';
import Label from '../../label';
import LabelText from '../../labelText';

type Props = {
  label: string,
  children: Node,
};

export default ({
  label,
  children,
}: Props) => (
  <FormRow>
    <Label>
      <LabelText>
        {label}
      </LabelText>
      <Flex width={breakpointsToArray({ default: 1, sm: 8 / 12 })}>
        {children}
      </Flex>
    </Label>
  </FormRow>
);
